var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestBeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#4B5162;}\n\t.st2{display:inline;}\n\t.st3{fill:#4B5162;}\n\t.st4{fill:#2C3149;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.9,28.9c-1.3-1.3-2.8-2.2-4.5-2.7c1.7-1.3,2.8-3.4,2.8-5.7c0-4-3.3-7.3-7.3-7.3s-7.3,3.3-7.3,7.3 c0,2.3,1.1,4.4,2.8,5.8C6,27.5,2.7,31.6,2.7,36.4c0,0.6,0.4,1,1,1s1-0.4,1-1c0-4.8,3.9-8.6,8.6-8.6h1.5l0,0l0,0h1.5 c4.8,0,8.6,3.9,8.6,8.6c0,0.6,0.4,1,1,1s1-0.4,1-1C27,33.5,25.9,30.9,23.9,28.9z M9.6,20.4c0-2.9,2.4-5.3,5.3-5.3s5.3,2.4,5.3,5.3 s-2.4,5.3-5.3,5.3l0,0C11.9,25.7,9.6,23.4,9.6,20.4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 10.92, 511.47)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_34-2_2_",
    transform: "translate(14.3 8.32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.4-515.2l3.3,5.7l-3.3,5.7h-6.6l-3.3-5.7l3.3-5.7H6.4 M7.6-517.2h-8.9l-4.5,7.7l4.5,7.7h8.9l4.5-7.7 L7.6-517.2L7.6-517.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.4-515.2l3.3,5.7l-3.3,5.7h-6.6l-3.3-5.7l3.3-5.7H6.4 M7.6-517.2h-8.9l-4.5,7.7l4.5,7.7h8.9l4.5-7.7 L7.6-517.2L7.6-517.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_890_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.7,38H14.1c-2.2,0-4.3-1.2-5.4-3.1c-1.1-1.9-1.2-4.3-0.1-6.2l0.1-0.1c0,0,4.6-8.2,5.6-9.9l0.1-8.5h-0.1 c-1.9,0-3.5-1.6-3.5-3.5c0-0.9,0.4-1.8,1-2.5c0.7-0.7,1.6-1.1,2.5-1l12.5,0c1.9,0,3.5,1.6,3.5,3.5c0,1.9-1.6,3.5-3.5,3.5h-0.1 l0,8.5l5.5,9.9c1.1,1.9,1.2,4.3,0,6.3C31,36.8,29,38,26.7,38z M28.7,30.5l-5.6-10c-0.3-0.5-0.4-1.1-0.4-1.7l0-11.7l-4.2,0 l-0.2,11.8c0,0.6-0.2,1.1-0.5,1.6c-0.8,1.4-5.7,10-5.7,10C16.9,26.5,22.3,31.9,28.7,30.5z M14.3,18.5 C14.3,18.5,14.3,18.5,14.3,18.5C14.3,18.5,14.3,18.5,14.3,18.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestBeaker);
export default __webpack_public_path__ + "static/media/TestBeaker.b4aebbd6958cd218746e89ab0a832e2b.svg";
export { ForwardRef as ReactComponent };